import {cDisplay} from '../creator/cDisplay'
import { cButton } from '../creator/cGameObjects/cButton';
import { cContainer } from '../creator/cGameObjects/cContainer';
import { cInlineDisplay } from '../creator/cGameObjects/cInlineDisplay';
import { cSprite } from '../creator/cGameObjects/cSprite';
import {cScene} from '../creator/cScene'
import { ScreenItem } from '../creator/dataTypes';


export class gameHershipDisplay extends cDisplay {

  private curScreen: cInlineDisplay
  private curSelected: any;
  private qData:any
  private curScore: any 
  private hideKids: any[] =  []

  init(){

    var cS:cScene = this.scene as cScene;
    var kids =  ['btn_kind_a','btn_kind_b','btn_kind_c','btn_kind_d']
    var formbtn =  ['btn_form_a','btn_form_b','btn_form_c','btn_form_d']

    super.init()
    console.log('INIT HershipDisplay 1');

    this.curSelected = null;
    this.curScore = 0;

    (this.scene as cScene).ev.addListener('action',(a,b,c)=>{
      console.log('HershipDisplay',a,b,c)
      switch (b.command){
        case 'select_person':
           kids.forEach( (nm)=>{
              var k = cS.getByName(nm)
              k.alpha = ( nm.indexOf('_'+b.payload.select) !== -1  ) ? 1 : 0
          })
          break;
        case 'check_last':

          var res = ['a','b','c','d'].forEach( (cur)=>{
            if (this.hideKids.indexOf(`btn_kind_${cur}`) === -1){
              var k = this.getByName(`btn_kind_${cur}`)
              k.alpha = 1
            }
          })

          cS.getByName('bg_formen').alpha = 0.2   
          cS.getByName('headline').textdata = ''        
          formbtn.forEach((nm)=>{
            cS.getByName(nm).visible = false
          })             

          if (this.areAllHidden()){
            if (this.curScore < 0) this.curScore = 0
            cS.triggerSceneEvent('close',{score: this.curScore});
          }
          break;
        case 'bubble':
          this.curSelected = b.payload.select
          this.enableButtons(true)
          var h = cS.getByName('headline')
          h.textdata = b.payload.msg
          formbtn.forEach((nm)=>{
            cS.getByName(nm).visible = true
          })
          cS.getByName('bg_formen').alpha = 1
          //cS.triggerSceneEvent('showhint');
          //this.returnToPosition(this.curSelected);
          break;
        case 'select':
          if (b.payload && b.payload.select){
            if (this.qData[ this.curSelected ] == b.payload.select){

              var idx = Object.keys(this.qData).indexOf(this.curSelected)
              cS.triggerSceneEvent('result',{value:String(idx)});
              this.getByName('btn_kind_' + this.curSelected).visible = false
              this.curScore ++
              this.hideKids.push( 'btn_kind_' + this.curSelected )
            }else{
              cS.triggerSceneEvent('result',{value:-1});
              this.curScore --
            }

          }
          this.enableButtons(false)
          break;
      }
    })

  }

  buildScene(){    
    super.buildScene();
    var d = this.getByName('DATA') as cSprite
    this.qData = d.modules.data._extraData;
  }

  enableButtons(opt){
    ['a','b','c','d'].forEach( (char)=>{
      var c = this.getByName(`btn_form_${char}`)
      if (c) c.enabled = opt
      var b = this.getByName(`btn_kind_${char}`)
      if (b) b.enabled = !opt
    } )
  }

  areAllHidden(){
    return this.hideKids.length === 4
  }


}
